import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { DevicesStore, InstallationFeaturesStore, RichDevice } from '@store';
import { Observable } from 'rxjs';
import { Feature, FeatureNames, ProductMatrixProperties } from '../../../../../projects/client';

@Component({
  selector: 'app-control-units-overlay',
  templateUrl: './control-units-overlay.component.html',
  styleUrls: ['./control-units-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlUnitsOverlayComponent implements OnInit {
  deviceProductMatrix$: Observable<Feature<ProductMatrixProperties, never>>;

  constructor(
    public devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.deviceProductMatrix$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.deviceProductMatrix
    );
  }

  trackBy(_index: number, device: RichDevice): string {
    return device.boilerSerial;
  }
}
